/* @flow */
import React from 'react';
// $FlowIgnore
import { connect } from 'react-redux';

import UserDropdown from 'components/UserDropdown';
import withRouting from 'utils/withRouting';
import * as qs from "qs";

let UserDropdownContainer = ({user, router, style}): React.Element => (
  <UserDropdown
    style={style}
    user={user}
    logout={() => {
      let { basename, pathname, query } = router.location;
      let nextUrl = Object.keys(query).length > 0 ? `${basename}${pathname}?=${qs.stringify(query)}` : `${basename}${pathname}`;
      let redirect = `/auth/logout?next=${nextUrl}`;
      location.assign(redirect);
    }}
  />
);

export default connect(
  state => ({
    user: state.auth.user,
  })
)(withRouting(UserDropdownContainer));
